if (!customElements.get('lc22-visual-comparison')) {
  customElements.define('lc22-visual-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      range.addEventListener('input', () => {
        const position = Math.min(100, Math.max(0, Number(range.value)));
        this.style.setProperty('--visual-position', `${position}%`);
        range.setAttribute('aria-valuetext', `${position} % du portrait avant affiché`);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
